import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import Translator from "@/components/Translator";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import Spiritual from "@/pages/Spiritual";
import Adventure from "@/pages/Adventure";
import TripPlanner from "@/pages/TripPlanner";
import About from "@/pages/About";
import ExperienceDetail from "@/pages/ExperienceDetail";
import FlightResults from "@/pages/FlightResults";
import BusResults from "@/pages/BusResults";
import HotelResults from "@/pages/HotelResults";
import CabResults from "@/pages/CabResults";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import MyBookings from "@/pages/MyBookings";
import Auth from "@/pages/Auth";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminExperiences from "@/pages/admin/AdminExperiences";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Translator />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/explore" element={<Explore />} />
          <Route path="/spiritual" element={<Spiritual />} />
          <Route path="/adventure" element={<Adventure />} />
          <Route path="/planner" element={<TripPlanner />} />
          <Route path="/about" element={<About />} />
          <Route path="/experience/:id" element={<ExperienceDetail />} />
          <Route path="/flights" element={<FlightResults />} />
          <Route path="/buses" element={<BusResults />} />
          <Route path="/hotels" element={<HotelResults />} />
          <Route path="/cabs" element={<CabResults />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/login" element={<Auth mode="login" />} />
          <Route path="/register" element={<Auth mode="register" />} />
          <Route path="/my-bookings" element={<ProtectedRoute><MyBookings /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
          <Route path="/admin/bookings" element={<ProtectedRoute adminOnly><AdminBookings /></ProtectedRoute>} />
          <Route path="/admin/experiences" element={<ProtectedRoute adminOnly><AdminExperiences /></ProtectedRoute>} />
          <Route path="/admin/enquiries" element={<ProtectedRoute adminOnly><AdminEnquiries /></ProtectedRoute>} />
        </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
